import { render, staticRenderFns } from "./ProfileAlert.vue?vue&type=template&id=fa60a932&scoped=true&"
import script from "./ProfileAlert.vue?vue&type=script&lang=js&"
export * from "./ProfileAlert.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAlert.vue?vue&type=style&index=0&id=fa60a932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa60a932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fa60a932', component.options)
    } else {
      api.reload('fa60a932', component.options)
    }
    module.hot.accept("./ProfileAlert.vue?vue&type=template&id=fa60a932&scoped=true&", function () {
      api.rerender('fa60a932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/alert/ProfileAlert.vue"
export default component.exports